export default "__VITE_ASSET__sod1h8ie__"